import { h, Component } from 'preact';
import {JavaScriptIcon, ReactIcon, CssIcon, HtmlIcon} from './../Icons'

export default class HackerNews extends Component {
	render() {
		return (
      <section class="Content border">
        <div class="Container">
          <div class="Product">
            <div class="info">
              <div class="Title">
                <span class="text">Chrome Extension, 2017</span>
              </div>
              <p>
                A super simple chrome extension to that displays Hacker News stories in new tabs.
              </p>
              <span style={{ width:'100%' }}>
								<JavaScriptIcon />
								<ReactIcon />
								<HtmlIcon />
								<CssIcon />
							</span>
              <a href="https://github.com/samcorin/hackernews-newtab-ext" class="Button">Source Code</a>
            </div>
            <div class="Image shadow border">
              <img src="https://firebasestorage.googleapis.com/v0/b/homepage-b9f4a.appspot.com/o/hn-screen.png?alt=media&token=a75d92f5-6ea4-4558-a091-f8286a275b5e" style={{ boxShadow: '0px 0px 26px #eee' }} alt="HN Chrome Extension" />
            </div>
          </div>
        </div>
      </section>
		);
	}
}



// WEBPACK FOOTER //
// ./components/hackernews/index.js